import { Assert } from "@jetjs/utils";
/**
 * Default Loading Strategy for Plugins: Assume that all plugins loaded before Parsing will be started.
 *
 * @public
 */
export class DefaultPluginLoader {
    init(registry) {
        this.registry = registry;
    }
    load(plugin) {
        return new Promise((resolve, reject) => {
            if (!Assert.defined(this.registry)) {
                reject(new Error("DefaultPluginLoader not initialized."));
            }
            else if (this.registry.isRegistered(plugin)) {
                resolve();
            }
            else {
                reject(new Error(`The default plugin loading strategy assumes that the Plugin ${plugin} should be already loaded.
          Load Plugins before the parsing will be started or choose a different loading strategy.`));
            }
        });
    }
    isLoaded(plugin) {
        if (!Assert.defined(this.registry)) {
            return false;
        }
        return this.registry.isRegistered(plugin);
    }
    getStrategyName() {
        return DefaultPluginLoader.NAME;
    }
}
DefaultPluginLoader.NAME = "default";
//# sourceMappingURL=DefaultPluginLoader.js.map